/**
 * SISTEMA DE ARMAZENAMENTO LOCAL
 * Gerencia dados de sessão do usuário de forma segura
 */

class SessionStorage {
    // Chaves para armazenamento
    static KEYS = {
        USER_SESSION: 'erp_user_session',
        USER_DATA: 'erp_user_data',
        LOGIN_TIME: 'erp_login_time'
    };

    /**
     * Salva dados da sessão do usuário
     * @param {Object} userData - Dados do usuário logado (vem do backend com estrutura completa)
     */
    static setUserSession(userData) {
        try {
            // Manter TODOS os dados que vêm do backend, sem transformar
            const sessionData = {
                ...userData, // Preserva todos os campos (cpf, nome, cargo, setor, permissoes, etc)
                loginTime: new Date().toISOString()
            };
            
            console.log('💾 SALVANDO SESSÃO - Dados recebidos:', userData);
            console.log('💾 userId:', userData.userId);
            console.log('💾 cpf:', userData.cpf);
            
            sessionStorage.setItem(this.KEYS.USER_SESSION, JSON.stringify(sessionData));
            sessionStorage.setItem(this.KEYS.LOGIN_TIME, sessionData.loginTime);
            
            // Verificar imediatamente se salvou
            const verificacao = sessionStorage.getItem(this.KEYS.USER_SESSION);
            console.log('✅ Sessão salva - Verificação imediata:', verificacao ? 'EXISTE' : 'NÃO EXISTE');
            if (verificacao) {
                const parsed = JSON.parse(verificacao);
                console.log('✅ Dados salvos - userId:', parsed.userId, 'cpf:', parsed.cpf);
            }
            
            return true;
        } catch (error) {
            console.error('❌ Erro ao salvar sessão:', error);
            return false;
        }
    }

    /**
     * Recupera dados da sessão atual
     * @returns {Object|null} - Dados do usuário ou null se não logado
     */
    static getUserSession() {
        try {
            console.log('📖 LENDO SESSÃO - Key:', this.KEYS.USER_SESSION);
            const sessionData = sessionStorage.getItem(this.KEYS.USER_SESSION);
            console.log('📖 Dados brutos do storage:', sessionData);
            
            if (!sessionData) {
                console.log('⚠️ sessionData é null/undefined');
                return null;
            }
            
            const parsed = JSON.parse(sessionData);
            console.log('📖 Dados parseados:', parsed);
            return parsed;
        } catch (error) {
            console.error('❌ Erro ao recuperar sessão:', error);
            return null;
        }
    }

    /**
     * Verifica se existe uma sessão ativa
     * @returns {boolean} - true se logado, false se não
     */
    static hasActiveSession() {
        console.log('🔍 VERIFICANDO SESSÃO ATIVA...');
        const session = this.getUserSession();
        console.log('🔍 Sessão recuperada:', session);
        
        if (session === null) {
            console.log('❌ Session é NULL');
            return false;
        }
        
        console.log('🔍 session.userId:', session.userId);
        console.log('🔍 session.cpf:', session.cpf);
        
        const temUserId = !!session.userId;
        const temCpf = !!session.cpf;
        const resultado = session !== null && (session.userId || session.cpf);
        
        console.log('🔍 Tem userId?', temUserId);
        console.log('🔍 Tem cpf?', temCpf);
        console.log('🔍 Resultado final hasActiveSession:', resultado);
        
        return resultado;
    }

    /**
     * Remove todos os dados de sessão (logout)
     */
    static clearSession() {
        try {
            sessionStorage.removeItem(this.KEYS.USER_SESSION);
            sessionStorage.removeItem(this.KEYS.USER_DATA);
            sessionStorage.removeItem(this.KEYS.LOGIN_TIME);
            
            console.log('✅ Sessão removida com sucesso');
            return true;
        } catch (error) {
            console.error('❌ Erro ao limpar sessão:', error);
            return false;
        }
    }

    /**
     * Verifica se a sessão expirou (opcional - para segurança extra)
     * @param {number} hoursLimit - Limite de horas para expiração (padrão: 8h)
     * @returns {boolean} - true se expirou, false se ainda válida
     */
    static isSessionExpired(hoursLimit = 8) {
        const loginTime = sessionStorage.getItem(this.KEYS.LOGIN_TIME);
        if (!loginTime) return true;
        
        const loginDate = new Date(loginTime);
        const now = new Date();
        const hoursDiff = (now - loginDate) / (1000 * 60 * 60);
        
        return hoursDiff > hoursLimit;
    }
}

export default SessionStorage;